/**
 * @Description: 新闻
 * @author: Xiao'Hong
 * @date: 2021/2/22
 * @fileName: news
 */
export  default  [
    {path: "/news", component: () => import('@/views/news/news.vue')},
]
